import { render, staticRenderFns } from "./PayView.vue?vue&type=template&id=2d3f4dfb&scoped=true"
import script from "./PayView.vue?vue&type=script&lang=js"
export * from "./PayView.vue?vue&type=script&lang=js"
import style0 from "./PayView.vue?vue&type=style&index=0&id=2d3f4dfb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3f4dfb",
  null
  
)

export default component.exports